import { render, staticRenderFns } from "./AccessRights.vue?vue&type=template&id=6273b118"
import script from "./AccessRights.vue?vue&type=script&lang=js"
export * from "./AccessRights.vue?vue&type=script&lang=js"
import style0 from "./AccessRights.vue?vue&type=style&index=0&id=6273b118&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports